@if (hasSelectableLayers$ | async) {
  <div class="map-control-button-container">
    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [tmTooltip]="tooltip()">
      <mat-button-toggle [class.selected]="toolActive$ | async" (click)="toggleTool()" (keydown.enter)="toggleTool()">
        @if (isLoadingGeometries$ | async) {
          <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
        } @else {
          <mat-icon svgIcon="tools_snap"></mat-icon>
        }
      </mat-button-toggle>
      <mat-button-toggle class="drop-down-button"
                         #snappingDropdownTrigger="matMenuTrigger"
                         [matMenuTriggerFor]="dropdownMenu"
                         (keydown.enter)="snappingDropdownTrigger.toggleMenu()">
        <mat-icon svgIcon="drop_down"></mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-menu #dropdownMenu="matMenu" class="options-menu">
    @let selectedLayers = selectedLayers$ | async;
    @let cannotSelectMoreLayers = (selectedLayers?.size ?? 0) >= maxSelectedLayers;
    @if (cannotSelectMoreLayers) {
      <div>
      <tm-error-message [friendlyError]="true"
                        [show]="true"
                        i18n="@@core.snapping.unselect-layers-to-select-more">You can select a maximum of {{maxSelectedLayers}} layers for snapping. Unselect layers before selecting others.</tm-error-message>
      </div>
    }
    @for (layer of (selectableLayers$ | async); track layer.id) {
      @let selectedLayer = selectedLayers?.has(layer.id);
      <button mat-menu-item
              class="menu-item"
              [tmTooltip]="layer.title"
              [disabled]="cannotSelectMoreLayers && !selectedLayer"
              [matTooltipPosition]="'before'"
              (click)="toggleLayer(layer)">
        @if (selectedLayer) {
          <mat-icon svgIcon="check"></mat-icon>
        }
        {{ layer.title }}
      </button>
    }
  </mat-menu>
}
